import { render, staticRenderFns } from "./Farmers.vue?vue&type=template&id=9c60bc12&scoped=true&"
import script from "./Farmers.vue?vue&type=script&lang=js&"
export * from "./Farmers.vue?vue&type=script&lang=js&"
import style0 from "./Farmers.vue?vue&type=style&index=0&id=9c60bc12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c60bc12",
  null
  
)

export default component.exports